<template>
    <div style="height: 100%">
        <div id="main" v-show="!rotaAninhada">
            <container-loader v-if="isLoading && !$store.getters.isLoading" />
            <div class="promotores">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t('mypromoters') }}
                            <a class="pl-1" v-if="hide.hideInfo" @click="infoIsHidden()">
                                <b-icon
                                    v-if="!hide.infoIsHidden"
                                    icon="eye-off-outline"
                                    type="is-danger"
                                />
                                <b-icon
                                    v-if="hide.infoIsHidden"
                                    icon="eye-outline"
                                    type="is-success"
                                />
                            </a>
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a>{{ $t('promotor') }}</a>
                                </li>
                                <li>
                                    <a href="#" aria-current="page">{{ $t('mypromoters') }}</a>
                                </li>
                            </ul>
                        </nav>
                        <div class="search-and-filter">
                            <div class="search-bar">
                                <search-bar
                                    :onSearch="debouncedOnSearch"
                                />
                            </div>
                            <div class="item-input">
                                <label for="situacao" v-text="$t('situacao')" />
                                <s-select
                                    v-model="info.situacao"
                                    :options="situacoes"
                                    :selectHeight="40"
                                    @input="onSituacaoChanged"
                                    useML
                                />
                            </div>
                        </div>
                        <div class="promoter-cards">
                            <container-loader v-if="isLoading && !$store.getters.isLoading" />
                            <div class="cards columns is-multiline is-variable is-1">
                                <div
                                    class="column is-one-third"
                                    v-for="(promotor, i) of promotores"
                                >
                                    <div class="card">
                                        <div class="img">
                                            <div class="rounder">
                                                <img :src="require('@/assets/img/user.svg')" alt />
                                            </div>
                                        </div>
                                        <div class="content">
                                            <div>
                                                <div class="nome">
                                                    <HideInfo
                                                        v-if="!cleanHide"
                                                        :value="promotor.nome"
                                                        :hideInfo="hide.hideInfo"
                                                        :infoIsHidden="hide.infoIsHidden"
                                                    />
                                                </div>
                                                <div
                                                    class="status"
                                                    :class="{
                                                        ocioso: promotor.status == 'ocioso',
                                                        finalizado: promotor.status == 'finalizado',
                                                        intervalo: promotor.status == 'intervalo',
                                                        'em-atendimento':
                                                            promotor.status == 'em-atendimento',
                                                    }"
                                                >
                                                    {{ $t(promotor.status) }}
                                                </div>
                                                <div
                                                    class="utilizacao"
                                                    v-if="promotor.dataatendimento"
                                                >
                                                    {{ $t('ultima-atualizacao') }}:
                                                    {{
                                                        $moment().diff(
                                                            $moment(promotor.dataatendimento)
                                                        ) | duration('humanize')
                                                    }}
                                                </div>
                                                <div class="lps" v-if="promotor.lps">
                                                    {{ $t('lps') }}: {{ promotor.lps }}
                                                </div>
                                                <div class="cliente" v-if="promotor.industria">
                                                    {{ $t('cliente') }}: {{ promotor.industria }}
                                                </div>
                                            </div>
                                            <div class="btn-wrapper">
                                                <button
                                                    class="button btn-add-small m-0"
                                                    @click="promptForRedirect(promotor)"
                                                >
                                                    {{ $t('detalhes') }}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <PaginationViewer
                                class="mb-0"
                                :resetPagination="pagination.resetPagination"
                                :totalItems="pagination.totalRows"
                                :perPageOptions="pagination.perPageOptions"
                                :optionStarted="pagination.optionStarted"
                                @change="updatePagination"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <router-view />
    </div>
</template>

<script>
import MeusPromotoresService from '@/services/MeusPromotoresService';
import ContainerLoader from '@/components/content/loader/ContainerLoader';
import HideInfo from '@/components/shared/HideInfo';
import { mapState } from 'vuex';

export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name.includes('meuspromotores') && to.name != 'meuspromotores-list') {
            this.rotaAninhada = true;
        } else {
            this.rotaAninhada = false;
            this.carregarDados(this.pagination.currentPage);
        }
        next();
    },
    components: {
        ContainerLoader,
        HideInfo,
    },
    data() {
        return {
            rotaAninhada: false,
            cleanHide: true,
            service: new MeusPromotoresService(this.$http, this.$router),
            promotores: [],
            situacoes: [
                { id: 'todos', label: 'todos' },
                { id: 'ocioso', label: 'ocioso' },
                { id: 'intervalo', label: 'intervalo' },
                { id: 'finalizado', label: 'finalizado' },
                { id: 'em-atendimento', label: 'em-atendimento' },
            ],
            info: {
                page: 1,
                limit: 12,
                situacao: { id: 'todos', label: 'todos' },
                param: '',
            },
            isLoading: false,
            pagination: {
                resetPagination: false,
                perPageOptions: [12, 24, 48, 96],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
        };
    },
    computed: {
        ...mapState(['hide']),
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        this.permissao = this.hasPermissionAccess('promotor', 'mypromoters', 'meuspromotores');
        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'mypromoters' },
            });
            return;
        }

        this.rotaAninhada =
            this.$route.name.includes('meuspromotores') &&
            this.$route.name != 'meuspromotores-list';

        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.carregarDados();
    },
    methods: {
        infoIsHidden() {
            this.$store.dispatch('infoIsHidden', { infoIsHidden: !this.hide.infoIsHidden });
        },
        updatePagination(value) {
            this.cleanHide = true;
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        onSearch(value) {
            this.info.param = value;
            this.carregarDados();
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            this.info.page = currentPage;
            this.info.limit = this.pagination.perPage;
            this.isLoading = true;
            this.service
                .getPromotores(this.info)
                .then((res) => {
                    if (res.content) {
                        this.cleanHide = false;
                        this.promotores = res.content;
                        this.cleanHide = true;
                        this.$forceUpdate();
                    }
                    this.pagination.totalRows = res.totalElements;
                })
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os dados.');
                })
                .finally(() => {
                    this.cleanHide = false;
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        onSituacaoChanged() {
            this.carregarDados();
        },
        getSituacaoLabel(option) {
            if (option.label != undefined) {
                return this.$t(option.label);
            } else if (typeof option == 'string') {
                return this.$t(option);
            } else {
                return option.label;
            }
        },
        promptForRedirect(promotor) {
            let admin = this.$store.state.user.admin;

            if (!this.$store.state.user.gmapsApiKey && admin) {
                /* Admin: Mostra a opção de ir na config pra inserir a chave. */
                this.$root.confirm({
                    message: this.$t('msg-geoanalise-no-keys-admin'),
                    onConfirm: this.redirectConfigMapa,
                });
            } else if (!this.$store.state.user.gmapsApiKey && !admin) {
                /* User. Somente mostra o aviso pois ele não tem permissão da chave. */
                this.$root.alert({
                    message: this.$t('msg-geoanalise-no-keys-user'),
                });
            } else {
                this.$router.push({ name: 'meuspromotores-view', params: { id: promotor.idusuario } });
            }
        },
        redirectConfigMapa() {
            this.$router.push({ name: 'configuracao-mapas' });
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
}

.promoter-cards {
    margin: 0 -15px;

    .cards {
        padding: 16px;
        align-content: flex-start;
        min-height: calc(100vh - 250px);

        .card {
            height: 16vh;
            min-height: 116px;
            display: flex;
            padding: 5px;
            .img {
                width: 82px;
                display: flex;
                flex-wrap: wrap;
                align-content: center;
                .rounder {
                    height: 74px;
                    width: 74px;
                    max-width: 74px;
                    border: 2px solid $primary-color;
                    border-radius: 50%;
                    margin: 4px;
                }
            }
            .content {
                width: calc(100% - 82px);
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                align-content: space-between;
                height: 100%;
                padding: 4px;
                > div {
                    width: 100%;
                    &.btn-wrapper {
                        display: flex;
                        justify-content: flex-end;
                    }
                    .nome {
                        font-style: normal;
                        font-weight: 600;
                        font-size: 17px;
                        line-height: 21px;
                        color: $primary-color;
                        width: 100%;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                    .status {
                        font-style: normal;
                        font-weight: 600;
                        font-size: 11px;
                        line-height: 13px;
                        &.ocioso {
                            color: $darker-gray-color;
                        }
                        &.intervalo {
                            color: $blue-alert-click;
                        }
                        &.em-atendimento {
                            color: $orange-alert;
                        }
                        &.finalizado {
                            color: $green-alert;
                        }
                    }
                    .utilizacao,
                    .lps,
                    .cliente {
                        width: 100%;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        font-style: normal;
                        font-weight: 500;
                        font-size: 11px;
                        line-height: 13px;
                        color: $darker-gray-color;
                    }
                }
            }
        }
    }

    .cards-pagination {
        width: fit-content;
        padding-left: 15px;
    }
}

.search-and-filter {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    margin-bottom: 20px;

    .search-bar {
        width: calc(80% - 5px);
    }

    .item-input {
        width: calc(20% - 5px);

        > .v-select {
            height: 40px;
        }
    }
}

@media only screen and (max-width: 760px) {
    .promotores button {
        display: inline-flex;
    }

    .search-and-filter {
        flex-wrap: wrap;

        .search-bar,
        .item-input {
            width: 100%;
        }
    }
}
</style>
